import Buttons from "components/molecules/buttons";
import { Form } from "components/organisms";
import { videoInitialValues } from "components/organisms/forms/video/VideoForm";

import { useParamId } from "hooks/useParamId";
import { t } from "i18next";
import middleware from "middleware";
import { useLocation, useNavigate } from "react-router-dom";
import { PopupActions } from "reactjs-popup/dist/types";
import { STATUS } from "services/types";
import { useDeleteVideo, useGetVideo } from "services/video";
import { getMainTitle } from "utils/global/mainTitle.utils";
import { getLastPathname } from "utils/navbar/getParentPathname";
import { onErrorShowToast } from "utils/service/errorHandler";

const Video = () => {
  const videoId = useParamId("video");
  const { pathname } = useLocation();

  const navigate = useNavigate();

  const removeVideo = useDeleteVideo(videoId);
  const { data: video, isLoading } = useGetVideo(videoId);

  const onRemoveVideo = async (actions: PopupActions) => {
    await removeVideo?.mutateAsync(undefined, {
      onError: (error) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => {
        navigate("/video");
      },
    });
  };

  return (
    <Form.Video
      i18nextPrefix="video"
      initialValues={
        video ? middleware.video.queryToForm(video) : videoInitialValues
      }
      onSubmit={() => {}}
      tittle={getMainTitle(video?.mainTitle)}
      status={{ isLoading: isLoading, displayMode: true }}
      topbarContent={
        <Buttons.IndividualPage
          onClick={() =>
            navigate(`/video/edit/${videoId}/${getLastPathname(pathname)}`, {
              replace: true,
            })
          }
          editDisabled={
            video?.videoStatus !== STATUS.draft &&
            video?.originalVideoLink === null
          }
          editDisabledDescription={t("button.editBlocked-file")}
          name={video?.mainTitle.title}
          onRemove={onRemoveVideo}
        />
      }
    />
  );
};

export default Video;
